import Image from "next/image";
import QrCodeContainer from "./qr-code-container";
import BtmCtaEn from "@public/btm-cta-en.png";
import BtmCtaBm from "@public/btm-cta-bm.png";
import BtmCtaZh from "@public/btm-cta-zh.png";
import DownloadNowImage from "./download-now-image";
import { Trans } from "@lingui/macro";
import { useRouter } from "next/router";

const BottomCta: React.FunctionComponent = () => {
  const { locale } = useRouter();

  const screenshot = {
    en: BtmCtaEn,
    bm: BtmCtaBm,
    zh: BtmCtaZh,
  };

  return <div className="py-2"></div>;

  return (
    <div className="relative pt-40">
      <div className="absolute top-16 -right-16 z-10 md:right-[50%]">
        <div className="md:pr-12">
          <Image
            src={screenshot[locale]}
            alt="lumi screenshot"
            width={350}
            height={640}
          />
        </div>
      </div>

      <div
        className="-mx-4 bg-primary2 px-6 pb-10 pt-[600px] md:pt-36 md:pb-24"
        style={{
          clipPath: "polygon(0 80px, 100% 0, 100% 100%, 0 100%)",
        }}
      >
        <div className="mx-auto max-w-3xl">
          <div className="md:ml-[50%] md:w-1/2 md:pl-12">
            <p className="text-center font-poppins text-2xl font-bold text-white md:text-left">
              <Trans>An easier way to get news and share it 🔥</Trans>
            </p>

            <div className="mt-8 px-8 md:px-0">
              <div className="flex items-center">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white">
                  ☕
                </div>
                <div className="ml-4 flex-1">
                  <p className="font-poppins text-light-background">
                    <Trans>Get the latest COVID-19 news</Trans>
                  </p>
                </div>
              </div>
              <div className="mt-4 flex items-center">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white">
                  🔔
                </div>
                <div className="ml-4 flex-1">
                  <p className="font-poppins text-light-background">
                    <Trans>Share with your family & friends</Trans>
                  </p>
                </div>
              </div>
              <div className="mt-4 flex items-center">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white">
                  ✅
                </div>
                <div className="ml-4 flex-1">
                  <p className="font-poppins text-light-background">
                    <Trans>Know when something trends</Trans>
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 text-center sm:hidden">
              <DownloadNowImage
                locale={locale}
                eventName={"Download Button CTA"}
              />
            </div>

            <div className="mt-8 hidden sm:block">
              <QrCodeContainer
                size="medium"
                text={<Trans>Scan to download the Lumi News app</Trans>}
                initialUrl="https://link.luminews.my/ewC9/qrdl"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomCta;
